export const AVATAR_TOOLTIP_STORAGE_ITEM = 'app-space:showTooltipAvatar'

export const HIDE_AVATAR_TOOLTIP_TIMEOUT = 5000
